import React from 'react';
import { AppBar, Toolbar } from '@mui/material';
import { useModeTokens } from '@/common/components/ui';
import { HeaderLeft, HeaderCenter, HeaderRight } from './components';

interface HeaderProps {
  onToggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar }) => {
  const t = useModeTokens();

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        top: 0,
        left: 0,
        width: '100%',
        maxWidth: 'none',
        borderRadius: 0,
        bgcolor: t.surfaces.glassHeader,
        border: 0,
        borderBottom: `1px solid ${t.borders.subtle}`,
        boxShadow: t.shadows.cardFlat,
        px: { xs: 2, sm: 1 },
        overflow: 'hidden',
      }}
    >
      <Toolbar
        sx={{
          position: 'relative',
          px: { xs: 0.25, sm: 2 },
          minHeight: { xs: 56, sm: 56 },
        }}
      >
        <HeaderLeft onToggleSidebar={onToggleSidebar} />
        <HeaderCenter />
        <HeaderRight />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
